export default __webpack_public_path__ + "static/media/SWT1990.34I-42347_-26089_0.be9f56d3.jpg";